import dotenv from 'dotenv';

dotenv.config();

export const productionConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    tpfHost: 'https://play.motorsportzone.co.za',
    nodeEnv: `Prod`
}

export const developmentConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_FANTASY_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    tpfHost: 'https://staging-play.motorsportzone.co.za',
    nodeEnv: `Dev`
}

export const stagingConfig = {
    dcbService: `${process.env.VUE_APP_STAGING_DCB_SERVICE}`,
    triviaService: `${process.env.VUE_APP_TRIVIA_SERVICE}`,
    triviaBasicAuthToken: `${process.env.VUE_APP_TRIVIA_BASIC_AUTH_TOKEN}`,
    utilsService: `${process.env.VUE_APP_UTILS_SERVICE}`,
    fantasyService: `${process.env.VUE_APP_STAGING_FANTASY_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
    predictorService: `${process.env.VUE_APP_PREDICTOR_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    authHeaderUnsubscribe: `${process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE}`,
    azureBlob: `${process.env.VUE_APP_AZURE_BLOB}`,
    myMuzeUrl : `${process.env.VUE_APP_MY_MUZE_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    tpfHost: 'https://staging-play.motorsportzone.co.za',
    nodeEnv: `Prod`
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return developmentConfig
    if (environment === 'production') return productionConfig
}
